import {createGlobalStyle} from 'styled-components';

export default createGlobalStyle`
  html {
    overflow: scroll;
    overflow-x: hidden;
}

::-webkit-scrollbar {
	width: 12px;
  height: 12px;
}
::-webkit-scrollbar-thumb {
	background: #ccc;
	border-radius: 0.625rem;
}

  :root {
    --BackgroundColor: #fff;
    --BackgroundLight: #F4F5F7;
    --BackgroundLighter: #FBFCFD;
    --BackgroundGray: #f8f8f9;
    --BackgroundGrey: #F7F8FA;
    --LightGray: #f0f0f0;
    --MediumGray: #989898;
    --ContrastGray: #3E464E;
    --DarkGray: #5D6E81;
    --PrimaryGreen: #207245;
    --SecondaryGreen: #1B643C;
    --PrimaryRed: #f54b23;
    --PrimaryBlue: #007AFF;
    --SecondaryBlue: #006BE1;
    --ThirdBlue: #B8CFD9;
   
  }

  html, body{height: 100%;}
  body {
    
    background-color: var(--BackgroundGrey);
    margin: 0;
    font-family: 'Proxima Nova', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size:14px;
  
   
  }

  h1, h2, h3, h4, h5, h6 {
    /* font-family: 'Cabin';
    color: var(--textColor); */
  }
  
  
  #root{
    height: 100%;
  }
`;
